import styled from 'styled-components/macro';
import { HeaderBlockDiv } from '../../components/HeaderBlockStyles';
import { defaultContainer } from '../../styles/utils';

export const SupportDiv = styled.div`
  ${defaultContainer}
  @media screen and (max-width: 767px) {
    ${HeaderBlockDiv} {
      margin-bottom: 1rem;
    }
  }
  span {
    color: ${props => props.theme.brand};
    text-decoration: underline;
    margin-left: 5px;
  }
  p {
    font-size: 15px;
  }
`;
